'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect2Wrapper = require('react-select2-wrapper');

var _reactSelect2Wrapper2 = _interopRequireDefault(_reactSelect2Wrapper);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _storageProvider = require('../../../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countries = [];

var Countries = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Countries, _React$PureComponent);

    function Countries() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Countries);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Countries.__proto__ || (0, _getPrototypeOf2.default)(Countries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: [].concat((0, _toConsumableArray3.default)(countries))
        }, _this.onChange = function (e) {
            var _this$props = _this.props,
                value = _this$props.value,
                onChange = _this$props.onChange;

            if (e.target.value !== value + '' && e.target.value !== '') {
                onChange(e);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Countries, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var selectedDeliveryId = this.props.selectedDeliveryId;


            var key = 'countries_delivery_type_id_' + (this.props.disabled ? 'disabled' : 'enabled') + '_' + selectedDeliveryId;
            var cachedValue = _storageProvider2.default.getValue(key);
            if (cachedValue) {
                this.setCountries(cachedValue);
                return;
            }
            // filter by delivery type only if is not disabled
            var selectedDeliveryFilter = this.props.disabled ? '' : '&selectedDeliveryId=' + selectedDeliveryId;
            (0, _ajax2.default)({ url: '/odata/CountryLookup?deliveryCountries=true' + selectedDeliveryFilter }).done(function (data) {
                _storageProvider2.default.setValue(key, data.value);
                _this2.setCountries(data.value);
            });
        }
    }, {
        key: 'setCountries',
        value: function setCountries(countriesData) {
            countries = countriesData.map(function (x) {
                return { id: x.id, text: x.name };
            });
            this.setState((0, _extends3.default)({}, this.state, { data: [].concat((0, _toConsumableArray3.default)(countries)) }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                value = _props.value,
                disabled = _props.disabled;
            var data = this.state.data;

            var val = value || '';
            if (data.length > 0) {
                var c = (0, _find2.default)(data, function (d) {
                    return d.id == value;
                });
                if (c === undefined) {
                    val = data[0].id;
                }
            }
            return _react2.default.createElement(_reactSelect2Wrapper2.default, { data: data, disabled: disabled, onClose: this.onChange, value: val });
        }
    }]);
    return Countries;
}(_react2.default.PureComponent), _class.propTypes = {
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
    selectedDeliveryId: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool
}, _temp2);
exports.default = Countries;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/Countries.js
// module id = 406
// module chunks = 0 2